import React from "react";
import ConfirmNavigate from "../ConfirmNavigate/ConfirmNavigate";
import type { NavigationBlocker } from "./NavigationBlocker";
import { useNavigationBlockerState, RegisterNavigationBlockerProvider } from "./NavigationBlocker";
export function NavigationBlockerProvider({ children }: {
    children: React.ReactNode;
}) {
    const { navigationBlocker, registerNavigationBlocker } = useNavigationBlockerState();
    return (<RegisterNavigationBlockerProvider registerNavigationBlocker={registerNavigationBlocker}>
            {children}
            {navigationBlocker !== null && <NavigateAwayPrompt navigationBlocker={navigationBlocker}/>}
        </RegisterNavigationBlockerProvider>);
}
function NavigateAwayPrompt({ navigationBlocker }: {
    navigationBlocker: NavigationBlocker;
}) {
    return (<ConfirmNavigate open={navigationBlocker.blocker.state === "blocked"} message={navigationBlocker.confirmationText} onCancelNavigation={() => navigationBlocker.blocker.reset?.()} onContinueNavigating={() => navigationBlocker.blocker.proceed?.()} onSaveClick={async () => {
            navigationBlocker.blocker.reset?.();
            await navigationBlocker.onSaveClick();
        }} saveLabel={navigationBlocker.saveLabel}/>);
}
